import type {
  AgentExecutionLight,
  ExecutionStatus,
} from "@stockline/shared/types/ai/execution"
import { EXECUTION_TABLE } from "../../../lib/offline/resources/ai/execution/db"
import { useAISync } from "../providers/AISyncProvider"
import { isSubagentExecution } from "./isSubagentExecution"

export interface UseExecutionsFilter {
  status?: ExecutionStatus
  agentType?: string
}

export function useExecutions(
  filter?: UseExecutionsFilter
): AgentExecutionLight[] {
  const { reactive } = useAISync()
  const rows = reactive.useQuery<AgentExecutionLight>(EXECUTION_TABLE, {
    ...filter,
    orderBy: "-createdAt",
  })
  // Hide sub-agent rows (forked / dispatched branches) so this list matches the
  // paged + count hooks — user-facing lists show only top-level runs. The
  // reactive query layer takes no predicate, so filter the materialized rows.
  return rows.filter((e) => !isSubagentExecution(e))
}
